/* eslint-disable @typescript-eslint/no-explicit-any */
import { Workbook } from '@syncfusion/ej2-excel-export';
import { extend } from '@syncfusion/ej2-base';
/**
 * Excel Export Module
 */
var ExcelExport = /** @class */ (function () {
    function ExcelExport(parent) {
        this.parent = parent;
    }
    ExcelExport.prototype.initializeExcelExport = function (excelExportOptions) {
        var _this = this;
        var exportFields = excelExportOptions.fields || Object.keys(this.parent.eventFields).map(function (field) {
            return _this.parent.eventFields[field];
        });
        var exportName = excelExportOptions.fileName || 'Schedule';
        var exportType = excelExportOptions.exportType || 'xlsx';
        var isIncludeOccurrences = excelExportOptions.includeOccurrences || false;
        var eventCollection;
        if (excelExportOptions.customData) {
            eventCollection = !isIncludeOccurrences ? excelExportOptions.customData :
                this.parent.eventBase.getProcessedEvents(excelExportOptions.customData);
        }
        else {
            eventCollection = !isIncludeOccurrences ? this.parent.eventsData : this.parent.eventsProcessed;
        }
        this.processWorkbook(exportFields, exportName, exportType, eventCollection);
    };
    ExcelExport.prototype.processWorkbook = function (fields, name, type, eventCollection) {
        var _this = this;
        var columns = [];
        var rows = [];
        var columnHeader = [];
        fields.forEach(function (field, i) { return columns.push({ index: i + 1, width: (field === 'Id' ? 20 : 150) }); });
        var style = { fontSize: 12, borders: { color: '#E0E0E0' }, bold: true };
        fields.forEach(function (field, i) { return columnHeader.push({ index: i + 1, value: field, style: style }); });
        rows.push({ index: 1, cells: columnHeader });
        var i = 2;
        var _loop_1 = function (event_1) {
            var columnData = [];
            fields.forEach(function (field, n) {
                var columnRule = { index: n + 1, value: event_1[field] || '' };
                if (field === _this.parent.eventFields.startTime || field === _this.parent.eventFields.endTime) {
                    var styleRule = { fontSize: 12, numberFormat: 'm/d/yyyy h:mm AM/PM' };
                    columnRule = extend({}, columnRule, { style: styleRule }, true);
                }
                columnData.push(columnRule);
            });
            rows.push({ index: i, cells: columnData });
            i++;
        };
        for (var _i = 0, eventCollection_1 = eventCollection; _i < eventCollection_1.length; _i++) {
            var event_1 = eventCollection_1[_i];
            _loop_1(event_1);
        }
        var workSheet = [{ columns: columns, rows: rows }];
        var book = new Workbook({ worksheets: workSheet }, type, this.parent.locale);
        book.save(name + '.' + type);
    };
    ExcelExport.prototype.getModuleName = function () {
        return 'excelExport';
    };
    ExcelExport.prototype.destroy = function () {
        this.parent = null;
    };
    return ExcelExport;
}());
export { ExcelExport };
